import { Link, useLoaderData } from 'react-router-dom';
import { Button, Table } from 'antd';
import { useTranslation } from 'react-i18next';

import type { AnnouncementsLoaderType } from './queries';
import type { IAnnouncement } from './types';

import { useAnnouncementsQuery } from './queries';
import { usePagination } from '@/hooks/usePagination';
import { useColumns } from './useColumns';
import { routes } from '@/app/router/routes';

import { PageHeader } from '@/ui/PageHeader';

export const Announcements = () => {
  const { t } = useTranslation();
  const initialData = useLoaderData() as AnnouncementsLoaderType;
  const { data: announcements, isLoading } = useAnnouncementsQuery(initialData);

  return (
    <>
      <PageHeader
        title={t('announcements.title')}
        description={t('announcements.description')}
        extra={
          <Link to={routes.announcementCreate()}>
            <Button type='primary'>{t('announcements.createButtonText')}</Button>
          </Link>
        }
      />
      <Table<IAnnouncement>
        rowKey='id'
        dataSource={announcements.data ?? []}
        loading={isLoading}
        columns={useColumns()}
        pagination={usePagination(announcements.total, announcements.per_page)}
        scroll={{ x: 'max-content' }}
      />
    </>
  );
};
